/* eslint-disable no-restricted-imports */
import {
	productPLPDiscountSX,
	productPLPPriceSX,
	productPLPSubtitleSX,
	productPLPTitleSX,
} from '@/components/content/CatalogEntryList/styles/typography';
import { combineSX } from '@/utils/combineSX';
import { Box, Typography } from '@mui/material';
import valueIsNullOrUndef from 'integration/utils/typeAssertions/valueIsNullOrUndef';

interface DpProductCardDescriptionProps {
	name: string;
	manufacturer: string;
	discount?: string | null;
	price?: string | null;
}

export const DpProductCardDescription = ({
	name,
	manufacturer,
	discount,
	price,
}: DpProductCardDescriptionProps) => (
	<>
		<Box>
			<Typography sx={productPLPTitleSX(false)}>{name}</Typography>
			<Typography sx={combineSX([productPLPSubtitleSX, { fontWeight: '300' }])}>
				{manufacturer}
			</Typography>
		</Box>
		<Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
			{discount ? <Typography sx={productPLPDiscountSX(false)}>{discount}</Typography> : null}
			<Typography sx={productPLPPriceSX(!valueIsNullOrUndef(discount), false)}>{price}</Typography>
		</Box>
	</>
);
